// hoc
import { withTypingTimer } from "shared/HOC/with-typing-timer";

// components
import { InputWithAddOns } from "shared/components/bulma/input";

const ITEM_NAME = 'product_search_field';

const options = [
    { value: "barcode", label: "Barcode" },
    { value: "supplier", label: "Supplier" },
    { value: "name", label: "Name" },
    { value: "brand", label: "Brand" }
];


const ProductsFilterBar = ({ name, onChange, onSelectChange, onKeyUp }) => {
    const initialValue = localStorage.getItem(ITEM_NAME) || options[0].value;

    const handleChange = (event) => {
        const { value } = event.target;
        localStorage.setItem(ITEM_NAME, value.select);

        if (onChange) {
            onChange(event);
        }
    }

    return (
        <InputWithAddOns
            name={name}
            placeholder="Type to search"
            options={options}
            onKeyUp={onKeyUp}
            onChange={handleChange} value={initialValue}>
            Search
        </InputWithAddOns>
    );
}

const ProductsFilterBarTimed = withTypingTimer(ProductsFilterBar);

export { ProductsFilterBarTimed };
